import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
    Select,
    InputLabel
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { getSupplierInfo,saveSupplierInfo, getCompanyTypes, updateSupplierInfo, fetchSuppliers } from '../service/supplierService';
import addressService from '../service/addressService'; 

const SupplierAddressManager: React.FC = () => {
  const [supplierAddresses, setSupplierAddresses] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    supplierId: "",
    address: {
      street1: "",
      street2: "",
      city: "",
      state: "",
      country: "",
      postalCode: "",
      phone: "",
      email: "",
      userId: "",
    },
    addressType: "",
  });
    
      const [suppliers, setSuppliers] = useState([]);

  useEffect(() => {
    fetchSupplierAddresses();
       fetchAllSuppliers();
  }, []);
    
      const fetchAllSuppliers = async () => {
    const res = await fetchSuppliers();
    setSuppliers(res.data);
  };

  const fetchSupplierAddresses = async () => {
    try {
      const response = await addressService.fetchSupplierAddresses();
      setSupplierAddresses(response);
    } catch (error) {
      console.error("Error fetching supplier addresses", error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name in formData.address) {
      setFormData({
        ...formData,
        address: { ...formData.address, [name]: value },
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
    
  const handleSupplierChange = (e) => {
    // The value from the Select component is the supplierId.
    const selectedSupplierId = e.target.value;

    // Update the state with the selected supplier's ID.
    setFormData({
      ...formData,
      supplierId: selectedSupplierId,
    });
  };


  const handleSave = async () => {
    try {
        
             if (
    !formData.supplierId ||
    !formData.addressType ||
    !formData.address.street1 ||
    !formData.address.street2 ||
    !formData.address.city ||
    !formData.address.state ||
    !formData.address.country ||
    !formData.address.postalCode ||
    !formData.address.phone ||
    !formData.address.email
  ) {
    alert("Please fill in all required fields.");
    return;
  }

  // Email format check (extra layer beyond type="email")
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(formData.address.email)) {
    alert("Please enter a valid email address.");
    return;
  }
        
        
      if (formData.id) {
        await addressService.updateSupplierAddresses(formData.id,formData); 
      } else {
        await addressService.saveSupplierAddresses(formData); //axios.post("/api/supplier-addresses", formData);
      }
      setOpen(false);
      fetchSupplierAddresses();
    } catch (error) {
      console.error("Error saving supplier address", error);
    }
  };

  const handleEdit = (row: any) => {
    setFormData(row);
    setOpen(true);
  };
    
      // Delete brand
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Address?")) {
      try {
        await addressService.deleteSupplierAddresses(id);// axiosInstance.delete(`/brands/${id}`);
        fetchSupplierAddresses();
      } catch (err) {
        console.error("Error deleting Address", err);
      }
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "supplierName", headerName: "Supplier Name", width: 120 },
    { field: "addressType", headerName: "Type", width: 120 },
    { field: "street1", headerName: "Street 1", width: 150, valueGetter: (params:any)=>params.row.address?.street1 },
    { field: "street2", headerName: "Street 2", width: 150, valueGetter: (params:any)=>params.row.address?.street2 },
    { field: "city", headerName: "City", width: 120, valueGetter: (params:any)=>params.row.address?.city },
    { field: "country", headerName: "Country", width: 120, valueGetter: (params:any)=>params.row.address?.country },
    { field: "phone", headerName: "Phone", width: 120, valueGetter: (params:any)=>params.row.address?.phone },
    { field: "email", headerName: "Email", width: 180, valueGetter: (params:any)=>params.row.address?.email },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params: any) => (
          <div>
        <Button variant="outlined" onClick={() => handleEdit(params.row)}>
          Edit
        </Button>
      <Button variant="outlined" onClick={() => handleDelete(params.row.id)}>
          Delete
        </Button>
</div>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <h2>Supplier Addresses</h2>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setFormData({
            id: null,
            supplierId: "",
            address: {
              street1: "",
              street2: "",
              city: "",
              state: "",
              country: "",
              postalCode: "",
              phone: "",
              email: "",
              userId: "",
            },
            addressType: "",
          });
          setOpen(true);
        }}
      >
        Add Supplier Address
      </Button>

      <div style={{ height: 400, marginTop: 20 }}>
        <DataGrid
          rows={supplierAddresses}
          columns={columns}
          pageSize={5}
          getRowId={(row) => row.id}
        />
      </div>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {formData.id ? "Edit Supplier Address" : "Add Supplier Address"}
        </DialogTitle>
        <DialogContent>
     <InputLabel id="supplier-label">Supplier</InputLabel>
      <Select
        labelId="supplier-label"
        id="supplierId"
        // Set the value of the Select to the selected supplier's ID.
        value={formData.supplierId || ''}
        onChange={handleSupplierChange}
        label="Supplier"
        required
        width="20px"
      >
        <MenuItem value="">
          <em>Select Supplier</em>
        </MenuItem>
        {suppliers.map((sup) => (
          // Use the unique ID as the value for each MenuItem.
          <MenuItem key={sup.supplierId} value={sup.supplierId}>
            {sup.supplierName}
          </MenuItem>
        ))}
      </Select>

          <TextField
            select
            label="Address Type"
            name="addressType"
            value={formData.addressType}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
            required
          >
            <MenuItem value="OFFICE">Office</MenuItem>
            <MenuItem value="BILLING">Billing</MenuItem>
            <MenuItem value="SHIPPING">Shipping</MenuItem>
          </TextField>
          <TextField
            label="Street 1"
            name="street1"
            value={formData.address.street1}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
            required
          />
          <TextField
            label="Street 2"
            name="street2"
            value={formData.address.street2}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
            required
          />
          <TextField
            label="City"
            name="city"
            value={formData.address.city}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
            required
          />
          <TextField
            label="State"
            name="state"
            value={formData.address.state}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Country"
            name="country"
            value={formData.address.country}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
            required
          />
          <TextField
            label="Postal Code"
            name="postalCode"
            value={formData.address.postalCode}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
            required
          />
          <TextField
            label="Phone"
            name="phone"
            value={formData.address.phone}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
            required
          />
          <TextField
            label="Email"
            name="email"
            type="email"
            value={formData.address.email}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
            required
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SupplierAddressManager;
